export const payload = {
  receiveMutation: 'RECEIVE_STATES',
  receivingMutation: 'RECEIVING_STATES',
  receiveMetadataMutation: 'RECEIVE_STATE_METADATA',
  receiveFailureMutation: 'RECEIVE_STATE_FAILURE',
  savingMutation: 'SAVING_STATE',
  saveFailureMutation: 'SAVING_STATE_FAILURE',
  incrementMutation: 'INCREMENT_STATE_COUNT',
  updatingMutation: 'UPDATING_STATE',
  updateFailureMutation: 'UPDATING_STATE_FAILURE',
  deleteMutation: 'DELETE_STATE',
  deletingMutation: 'DELETING_STATE',
  deleteFailureMutation: 'DELETING_STATE_FAILURE',
  resetMetaMutation: 'RESET_STATE_META',
  clearMutation: 'CLEAR_STATE_STATE',
  moduleName: 'state',
  endpoint: 'states',
  searchableFields: ['code', 'name']
}
